import PropTypes from 'prop-types';

export const LinkPropTypes = PropTypes.shape({
  type: PropTypes.exact('link'),
  label: PropTypes.string.isRequired,
  param: PropTypes.string.isRequired,
  paramValue: PropTypes.string.isRequired,
});
